import React from 'react';

type IosPrivacyPageProps = {
  appIconUrl: string;
  appStoreUrl: string;
};

export function IosPrivacyPage({appIconUrl, appStoreUrl}: IosPrivacyPageProps) {
  return (
    <main className="app">
      <section className="hero support-hero">
        <div className="hero-brand">
          <img className="hero-icon" src={appIconUrl} alt="Dashless app icon" />
          <p className="eyebrow">Dashless Privacy Policy</p>
        </div>
        <h1 className="title">iOS Privacy Policy</h1>
        <p className="subtitle">
          Last updated: 28 February 2026
        </p>
      </section>

      <section className="section privacy-content">
        <article className="card">
          <h3>Overview</h3>
          <p>
            This Privacy Policy explains how Dashless handles information when you
            use the iOS app.
          </p>
        </article>

        <article className="card">
          <h3>Information Dashless may access</h3>
          <p>
            Depending on your settings and enabled features, Dashless may access:
          </p>
          <ul className="feature-list">
            <li>Location data for speed and driving-related functionality</li>
            <li>Bluetooth data to connect to compatible OBD2 adapters</li>
            <li>Vehicle telemetry from connected OBD2 adapters</li>
            <li>Diagnostic trouble code data when diagnostics features are used</li>
            <li>Purchase and entitlement status for in-app purchases</li>
          </ul>
        </article>

        <article className="card">
          <h3>How information is used</h3>
          <p>
            Dashless uses this information to provide core app functionality,
            including dashboard speed display, telemetry visualization,
            diagnostics, and purchase unlocks.
          </p>
        </article>

        <article className="card">
          <h3>Data sharing</h3>
          <p>
            Dashless does not sell your personal information. Data may be processed
            by Apple services as required for App Store purchases and platform
            features.
          </p>
        </article>

        <article className="card">
          <h3>Data retention and control</h3>
          <p>
            You can control permissions from iOS Settings and stop using features
            that require location, Bluetooth, or diagnostics access at any time.
          </p>
        </article>

        <article className="card">
          <h3>Contact</h3>
          <p>
            For privacy questions, contact{' '}
            <a href="mailto:support@dashless.autos">support@dashless.autos</a>.
          </p>
        </article>
      </section>

      <footer className="footer">
        <p>Dashless for iOS</p>
        <div className="footer-links">
          <a href="/">Home</a>
          <a href="/support">Support</a>
          <a href={appStoreUrl} target="_blank" rel="noopener noreferrer">
            App Store
          </a>
        </div>
      </footer>
    </main>
  );
}
